import BlueprintFactory from './Factory';

module.exports = {
  BlueprintFactory
}
